<template>
  <v-container fluid>
    <options></options>
    <list></list>
    <div class="text-center text-caption mt-16 d-print-none">Win predictions and betting odds data are provided by <a href="https://www.statsperform.com/" target="_blank">Stats.com.</a></div>
  </v-container>
</template>


<script>
import Options from "../components/Home/Options";
import Tip from "../components/Home/Tip";
import List from "../components/Home/List";

import {
  GET_OPTIONS,
  GET_SELECTED_OPTIONS,
  GET_EVENTS,
  SET_PARAM_OPTIONS
} from "../store/actions.type";

export default {
  name: "Home",
  components: {
    Options,
    Tip,
    List,
  },
  computed: {
    hasParams() {
      return (this.$route.params.sport && this.$route.params.league && this.$route.params.date) ? true : false;
    }
  },
  async mounted() {
    if (this.hasParams) {
      this.$gtag.event("api", {
        event_category: "options",
        event_label: "set_options"
      });
      
      //Set URL based parameters and wait until complete.
      await this.$store.dispatch(SET_PARAM_OPTIONS, this.$route.params);
    }
    
    this.$gtag.event("api", {
      event_category: "options",
      event_label: "get_options"
    });
    
    this.$store
      .dispatch(GET_OPTIONS)
      .then(() => {
        this.$gtag.event("api", {
          event_category: "options",
          event_label: "get_selected_options"
        });
        this.$store.dispatch(GET_SELECTED_OPTIONS);
      })
      .then(() => {
        this.$gtag.event("api", {
          event_category: "options",
          event_label: "get_events"
        });
        this.$store.dispatch(GET_EVENTS);
      });
  },
};
</script>